import { processiFixtures } from "./fixtures/processi";

export type ProcessoStato = "Pronto per l'uso" | "In preparazione";
export type Processo = {
  id: string;
  nome: string;
  descrizione: string;
  stato: ProcessoStato;
  aggiornatoIl: string;
  passaggi: string[];
};

const delay = (ms: number) => new Promise<void>((resolve) => window.setTimeout(resolve, ms));

export async function listProcessi(): Promise<Processo[]> {
  await delay(240);
  return processiFixtures.map((processo) => ({ ...processo, passaggi: [...processo.passaggi] }));
}
